import React, { useRef, useEffect } from "react";
import {
  Grid,
  Button,
  IconButton,
  Box,
  Typography,
  Divider,
  FormControlLabel,
  Checkbox,
  Paper,
  Avatar,
} from "@mui/material";
import { Add, Remove } from "@mui/icons-material";
import CustomInput from "./CustomInput";

const ColorSizeManager = ({ variations, setVariations, isDarkMode }) => {
  const colorInputRefs = useRef({});

  const handleAddColor = () => {
    const newColorIndex = variations.length;
    setVariations([...variations, { color: "", sizes: [] }]);

    // Chờ setState xong, focus vào ô nhập màu mới
    setTimeout(() => {
      colorInputRefs.current[`color-${newColorIndex}`]?.focus();
    }, 100);
  };

  const handleColorChange = (index, value) => {
    const updated = [...variations];
    updated[index].color = value;
    setVariations(updated);
  };

  const handleRemoveColor = (index) => {
    const updated = variations.filter((_, i) => i !== index);
    setVariations(updated);
  };

  const handleAddSize = (colorIndex) => {
    const updated = [...variations];
    updated[colorIndex].sizes.push({ size: "", stock: "", status: "Y" });
    setVariations(updated);
  };

  const handleSizeChange = (colorIndex, sizeIndex, field, value) => {
    const updated = [...variations];
    updated[colorIndex].sizes[sizeIndex][field] = value;
    setVariations(updated);
  };

  const handleRemoveSize = (colorIndex, sizeIndex) => {
    const updated = [...variations];
    updated[colorIndex].sizes = updated[colorIndex].sizes.filter(
      (_, i) => i !== sizeIndex
    );
    setVariations(updated);
  };

  return (
    <Box>
      {variations.map((variation, colorIndex) => (
        <Paper
          elevation={2}
          sx={{
            p: 2,
            mb: 3,
            borderRadius: 2,
            backgroundColor: isDarkMode ? "#252525" : "#f9f9f9",
          }}
          key={colorIndex}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography variant="subtitle1" fontWeight="bold">
                🎨 Màu #{colorIndex + 1}
              </Typography>
              {/* Icon preview màu */}
              <Avatar
                variant="circular"
                sx={{
                  bgcolor: variation.color || "#ccc",
                  width: 24,
                  height: 24,
                  border: "1px solid #aaa",
                }}
              />
            </Box>
            <IconButton onClick={() => handleRemoveColor(colorIndex)} color="error">
              <Remove />
            </IconButton>
          </Box>

          <CustomInput
            inputRef={(el) => (colorInputRefs.current[`color-${colorIndex}`] = el)}
            label="Tên màu"
            value={variation.color}
            onChange={(e) => handleColorChange(colorIndex, e.target.value)}
            sx={{ mb: 2, width: "100%" }}
          />

          <Button
            variant="outlined"
            size="small"
            startIcon={<Add />}
            onClick={() => handleAddSize(colorIndex)}
            sx={{ mb: 2 }}
          >
            ➕ Thêm size
          </Button>

          {variation.sizes.map((size, sizeIndex) => (
            <Box key={sizeIndex} sx={{ mb: 2 }}>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} sm={4}>
                  <CustomInput
                    label="Size"
                    value={size.size}
                    onChange={(e) =>
                      handleSizeChange(colorIndex, sizeIndex, "size", e.target.value)
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <CustomInput
                    label="Tồn kho"
                    type="number"
                    value={size.stock}
                    onChange={(e) =>
                      handleSizeChange(colorIndex, sizeIndex, "stock", e.target.value)
                    }
                  />
                </Grid>
                <Grid item xs={10} sm={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={size.status === "Y"}
                        onChange={(e) =>
                          handleSizeChange(
                            colorIndex,
                            sizeIndex,
                            "status",
                            e.target.checked ? "Y" : "N"
                          )
                        }
                        sx={{
                          color: size.status === "Y" ? "green" : "red",
                          "&.Mui-checked": {
                            color: "green",
                          },
                        }}
                      />
                    }
                    label="Trạng thái"
                  />
                </Grid>
                <Grid item xs={2} sm={1}>
                  <IconButton
                    onClick={() => handleRemoveSize(colorIndex, sizeIndex)}
                    color="error"
                    size="small"
                  >
                    <Remove />
                  </IconButton>
                </Grid>
              </Grid>
              <Divider sx={{ mt: 1 }} />
            </Box>
          ))}
        </Paper>
      ))}

      <Box sx={{ textAlign: "center", mt: 3 }}>
        <Button
          variant="contained"
          color="primary"
          startIcon={<Add />}
          onClick={handleAddColor}
        >
          ➕ Thêm màu mới
        </Button>
      </Box>
    </Box>
  );
};

export default ColorSizeManager;
